import {Component, OnInit} from '@angular/core';
import {DataProviderService, IServiceCard} from '../shared/data-provider.service';
import {IList} from 'linq-collections/build/src/Collections';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-services',
  templateUrl: './services.component.html',
  styleUrls: ['./services.component.scss']
})
export class ServicesComponent implements OnInit {
  serviceCards: IList<IServiceCard>;
  url: string = 'assets/json/services.json';
  urlHu: string = 'assets/json/servicesHu.json';
  constructor(private _dataProviderService: DataProviderService,
              private translateService: TranslateService) {
  }

  ngOnInit(): void {
    this.translateService.onLangChange.subscribe(
      newLang => {
        if (newLang.lang === 'hu') {
          this._dataProviderService.getServiceCards(this.urlHu)
            .subscribe(
              storyBoardItems => {
                this.serviceCards = storyBoardItems;
              },
              error => console.log(error)
            );
        }
        if (newLang.lang === 'en') {
          this._dataProviderService.getServiceCards(this.url)
            .subscribe(
              storyBoardItems => {
                this.serviceCards = storyBoardItems;
              },
              error => console.log(error)
            );
        }
      }
    );
    this._dataProviderService.getServiceCards(this.url)
      .subscribe(
        serviceCards => this.serviceCards = serviceCards,
        error => console.log(error) // TODO show on UI
      );
  }
}



// WEBPACK FOOTER //
// C:/Projects/dod/companyintroduction/src/app/services/services.component.ts